import React from "react";
import Notice from "./Notice";
import UpcomingEvents from "./UpcomingEventsAll";

const NoticeAndUpcomingEvents = ({ noticeConfig }) => {
  return (
    <div id="notice">
      <p className="heading3 text-left">Notice & Events</p>
      <div className="noticeContainer">
        <ul
          id="noticeTab"
          className="nav nav-tabs"
          role="tablist"
          runat="server"
        >
          <li className="nav-item">
            <a
              className="nav-link active"
              href="#generalNotice"
              role="tab"
              data-toggle="tab"
            >
              General Notice
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              href="#UpcomingEvents"
              role="tab"
              data-toggle="tab"
            >
              Upcoming Events
            </a>
          </li>

          <li className="nav-item">
            <a
              className="nav-link "
              href="https://webportal.easternuni.edu.bd/Transport/_transportSchedule.aspx"
              target="_blank"
            >
              Transport Schedule
            </a>
          </li>
        </ul>

        <div className="tab-content">
          <div
            role="tabpanel"
            className="tab-pane fade show active"
            id="generalNotice"
          >
            <Notice noticeConfig={noticeConfig} />
          </div>
          <div role="tabpanel" className=" tab-pane fade " id="UpcomingEvents">
            <div className="Upcoming_Events">
              <UpcomingEvents config={noticeConfig} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoticeAndUpcomingEvents;
